<template>
  <div 
    class="scroll-container" 
    :style="{ height: height, width: width }"
  >
    <slot></slot>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  height: {
    type: String,
    default: '200px'
  },
  width: {
    type: String,
    default: '100%'
  }
});
</script>

<style scoped>
.scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
  white-space: nowrap;
  padding: 10px;
}
</style>
